import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import ChangePassword from "@/pages/ChangePassword";

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#F9F9F8]">
        <Loader2 className="h-8 w-8 animate-spin text-[#114A31]" />
      </div>
    );
  }
  if (user === false) {
    return <Navigate to="/login" replace />;
  }
  if (user.must_change_password) {
    return <ChangePassword forced />;
  }
  return children;
}
